/**
 * @generated SignedSource<<e301a57dae98df50bc74974087db9c9e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TryOnType = "BRACELET" | "EARRINGS" | "EYEWEAR" | "HEADWEAR" | "NECKLACE" | "NOT_SELECTED" | "SCARVES" | "SHOES" | "WATCHES";
export type SceneInput = {
  arFiles: ReadonlyArray<SceneARFileInput>;
  cameraLimitLowerRadius: boolean;
  cameraLocations: ReadonlyArray<SceneCameraLocationInput>;
  cameraPositionScale?: number | null;
  config: SceneConfigInput;
  fileLength?: number | null;
  fileObjectID?: number | null;
  id?: string | null;
  imageData?: string | null;
  imageFileLength?: number | null;
  imageLength?: number | null;
  imageUrl?: string | null;
  incrementalsFileLength?: number | null;
  incrementalsFileObjectID?: number | null;
  incrementalsFileUrl: string;
  manifestFileLength?: number | null;
  manifestFileObjectID?: number | null;
  manifestFileUrl: string;
  materialMappings: ReadonlyArray<SceneMaterialMappingInput>;
  materialPhotos: ReadonlyArray<SceneMaterialPhotoInput>;
  meshLocations: ReadonlyArray<SceneMeshLocationInput>;
  name: string;
  rootUrl: string;
  sceneFileName: string;
  sellerID: number;
  shaderMaterials: ReadonlyArray<SceneShaderMaterialInput>;
  sources: ReadonlyArray<SceneSourceInput>;
  textures: ReadonlyArray<SceneTextureInput>;
  url: string;
  useDefaultEnvironmentTexture: boolean;
  usedTextureUrls: ReadonlyArray<string>;
  version: number;
};
export type SceneConfigInput = {
  animations?: SceneAnimationsConfigInput | null;
  camera?: SceneCameraConfigInput | null;
  environment?: SceneEnvironmentConfigInput | null;
  general: SceneGeneralConfigInput;
  glow?: SceneGlowConfigInput | null;
  infoPoints?: SceneInfoPointsConfigInput | null;
  lights?: SceneLightsConfigInput | null;
  model?: SceneModelConfigInput | null;
  textures?: SceneTexturesConfigInput | null;
  uiConfig?: SceneUIConfigInput | null;
};
export type SceneGeneralConfigInput = {
  antialias?: AntiAliasingOptionsInput | null;
  antialiasEnabled?: boolean | null;
  arAnchor?: string | null;
  arEnabled?: boolean | null;
  arOnTheFly?: boolean | null;
  arScale?: boolean | null;
  backgroundAlpha?: number | null;
  backgroundColor?: string | null;
  contrast?: number | null;
  environmentOptions?: EnvironmentOptionsInput | null;
  environmentTexture?: string | null;
  exposure?: number | null;
  fitToScreenMargin?: number | null;
  forceDracoCompression?: boolean | null;
  frameDAMSettings?: string | null;
  matchSameNameTextures?: boolean | null;
  meshSize?: ArMeshSizeInput | null;
  prefetchMaterials?: boolean | null;
  prefetchMeshes?: boolean | null;
  preventDefaultLights?: boolean | null;
  removeDefaultBackground?: boolean | null;
  screenshotBackgroundColor?: string | null;
  tryOnEnabled?: boolean | null;
  tryOnSettings?: SceneTryOnSettingsConfigInput | null;
  useDelayedMaterialLoading?: boolean | null;
  useDelayedTextureLoading?: boolean | null;
  useMaterialOffloading?: boolean | null;
};
export type EnvironmentOptionsInput = {
  gammaSpace?: boolean | null;
  generateHarmonics?: boolean | null;
  intensity?: number | null;
  mipMaps?: boolean | null;
  pbrIntensity?: number | null;
  prefilterOnLoad?: boolean | null;
  rotationY?: number | null;
};
export type SceneTryOnSettingsConfigInput = {
  buttonCustomizations: ReadonlyArray<SceneTryOnButtonCustomizationConfigInput>;
  styleButton: string;
  type: TryOnType;
  typeSettings?: SceneTryOnTypeSettingsConfigInput | null;
};
export type SceneTryOnButtonCustomizationConfigInput = {
  backgroundColor?: string | null;
  borderColor?: string | null;
  borderRadius?: number | null;
  borderWidth?: number | null;
  image?: string | null;
  textColor?: string | null;
  textLabel?: string | null;
};
export type SceneTryOnTypeSettingsConfigInput = {
  active?: boolean | null;
  mandatoryPD?: boolean | null;
  pd?: boolean | null;
  try_on?: boolean | null;
};
export type ArMeshSizeInput = {
  depth?: number | null;
  height?: number | null;
  width?: number | null;
};
export type AntiAliasingOptionsInput = {
  desktop?: AntiAliasingDeviceOptionsInput | null;
  mobile?: AntiAliasingDeviceOptionsInput | null;
};
export type AntiAliasingDeviceOptionsInput = {
  enabled?: boolean | null;
  inRotationEnabled?: boolean | null;
};
export type SceneEnvironmentConfigInput = {
  backgroundColor?: string | null;
  ground?: SceneGroundConfigInput | null;
  mainColor?: string | null;
  shadows?: SceneShadowsConfigInput | null;
  sizeAuto?: boolean | null;
  skybox?: SceneSkyboxConfigInput | null;
};
export type SceneSkyboxConfigInput = {
  blur: number;
  color?: string | null;
  createSkybox: boolean;
  extensions?: ReadonlyArray<string> | null;
  files?: ReadonlyArray<string> | null;
  size?: number | null;
  texture?: string | null;
};
export type SceneGroundConfigInput = {
  color?: string | null;
  createGround: boolean;
  enableMirror?: boolean | null;
  enableShadow?: boolean | null;
  mirrorBlurKernel?: number | null;
  opacity?: number | null;
  shadowLevel?: number | null;
  size?: number | null;
  texture?: string | null;
};
export type SceneShadowsConfigInput = {
  blurBoxOffset?: number | null;
  blurKernel?: number | null;
  blurScale?: number | null;
  contactHardeningUVRatio?: number | null;
  depthScale?: number | null;
  enableShadows?: boolean | null;
  groundSizeMultiplierLength?: number | null;
  groundSizeMultiplierWidth?: number | null;
  shadowDarkness?: number | null;
  shadowHexColor?: string | null;
  shadowMapSize?: number | null;
  shadowMaxZ?: number | null;
  shadowMinZ?: number | null;
  useBlurCloseExponentialShadowMap?: boolean | null;
  useContactHardeningShadow?: boolean | null;
  useKernelBlur?: boolean | null;
  usePercentageCloserFiltering?: boolean | null;
  usePoissonSampling?: boolean | null;
};
export type SceneLightsConfigInput = {
  directionalLightBack?: SceneLightSettingInput | null;
  directionalLightLeft?: SceneLightSettingInput | null;
  hemisphereLight?: SceneLightSettingInput | null;
  pointLightBack?: SceneLightSettingInput | null;
  pointLightFront?: SceneLightSettingInput | null;
};
export type SceneLightSettingInput = {
  general?: SceneLightGeneralInput | null;
  position?: SceneLightPositionInput | null;
};
export type SceneLightPositionInput = {
  x?: number | null;
  y?: number | null;
  z?: number | null;
};
export type SceneLightGeneralInput = {
  intensity?: number | null;
  visible?: boolean | null;
};
export type SceneCameraConfigInput = {
  animateIntro?: boolean | null;
  autoRotate?: boolean | null;
  changeRotationDirection?: boolean | null;
  contrast?: number | null;
  exposure?: number | null;
  fixedAlphaAngle?: number | null;
  fixedBetaAngle?: number | null;
  initialZoomToBBInertiaDamping?: number | null;
  initialZoomToBBModelSizeRadius?: number | null;
  initialZoomToBBScrollLowerLimit?: number | null;
  initialZoomToBBScrollUpperLimit?: number | null;
  initialZoomToBBScrollZoomEnabled?: boolean | null;
  limitLowerRadius?: boolean | null;
  lowerAlphaLimit?: number | null;
  lowerBetaLimit?: number | null;
  maxZoomPerc?: number | null;
  minZoomPerc?: number | null;
  position?: SceneCameraPositionInput | null;
  positionScale?: number | null;
  rotationSpeed?: number | null;
  setInitialZoomToBoundingBox?: boolean | null;
  toneMappingEnabled?: boolean | null;
  toneMappingType?: number | null;
  upperAlphaLimit?: number | null;
  upperBetaLimit?: number | null;
  useLowerAlphaLimit?: boolean | null;
  useLowerBetaLimit?: boolean | null;
  useMaxZoomPerc?: boolean | null;
  useMinZoomPerc?: boolean | null;
  useUpperAlphaLimit?: boolean | null;
  useUpperBetaLimit?: boolean | null;
  zoom?: number | null;
  zoomEnabled?: boolean | null;
};
export type SceneCameraPositionInput = {
  alpha?: number | null;
  beta?: number | null;
  fov?: number | null;
  radius?: number | null;
};
export type SceneGlowConfigInput = {
  blurSize?: number | null;
  enabled: boolean;
  intensity?: number | null;
};
export type SceneInfoPointsConfigInput = {
  enabled: boolean;
  pointsStyle?: SceneInfoPointsStyleConfigInput | null;
};
export type SceneInfoPointsStyleConfigInput = {
  borderColor: string;
  color: string;
  highlightColor: string;
  innerPointColor: string;
};
export type SceneUIConfigInput = {
  urlARIcon?: string | null;
  urlLoader?: string | null;
};
export type SceneTexturesConfigInput = {
  format: string;
  webpOptions?: WebPOptionsInput | null;
};
export type WebPOptionsInput = {
  quality: number;
  type: string;
};
export type SceneModelConfigInput = {
  config?: SceneModelConfigOptionInput | null;
  position?: SceneModelCoordinateInput | null;
  rotation?: SceneModelCoordinateInput | null;
  scale?: SceneModelCoordinateInput | null;
};
export type SceneModelCoordinateInput = {
  x?: number | null;
  y?: number | null;
  z?: number | null;
};
export type SceneModelConfigOptionInput = {
  doubleSided?: boolean | null;
};
export type SceneAnimationsConfigInput = {
  loop?: boolean | null;
  runAtStart?: boolean | null;
  speed?: number | null;
};
export type SceneSourceInput = {
  fileLength?: number | null;
  fileObjectID?: number | null;
  rootUrl: string;
  sceneFileName: string;
  sourceID: any;
  textures: ReadonlyArray<SceneSourceTextureInput>;
  url: string;
};
export type SceneSourceTextureInput = {
  fileLength?: number | null;
  fileObjectID?: number | null;
  textureID: any;
  url: string;
};
export type SceneCameraLocationInput = {
  locationID: any;
  name: string;
  px: number;
  py: number;
  pz: number;
  tx: number;
  ty: number;
  tz: number;
};
export type SceneMaterialMappingInput = {
  libraryMaterialID: any;
  sceneMaterialID: any;
};
export type SceneTextureInput = {
  fileLength?: number | null;
  fileObjectID?: number | null;
  isDefaultEnvironment: boolean;
  materialID: any;
  textureID: any;
  url: string;
  usage: number;
};
export type SceneMaterialPhotoInput = {
  displayOrder: number;
  fileLength?: number | null;
  fileObjectID?: number | null;
  materialID: any;
  photoID: any;
  url: string;
};
export type SceneShaderMaterialInput = {
  fragment: string;
  materialID: any;
  name: string;
  vertex: string;
};
export type SceneMeshLocationInput = {
  adjustCamera: boolean;
  data: ReadonlyArray<any>;
  displayOrder: number;
  imageUrl: string;
  isCollapsed: boolean;
  isExploded: boolean;
  locationID: any;
  name: string;
  tempImageFileKey: string;
  tempImageFileUrl: string;
};
export type SceneARFileInput = {
  fileID: any;
  fileType: string;
  url: string;
};
export type useSaveProductOptimizedSceneMutation$variables = {
  input: SceneInput;
};
export type useSaveProductOptimizedSceneMutation$data = {
  readonly updateScene: {
    readonly scene: {
      readonly id: string;
    } | null;
  };
};
export type useSaveProductOptimizedSceneMutation = {
  response: useSaveProductOptimizedSceneMutation$data;
  variables: useSaveProductOptimizedSceneMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SceneOutput",
    "kind": "LinkedField",
    "name": "updateScene",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Scene",
        "kind": "LinkedField",
        "name": "scene",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveProductOptimizedSceneMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSaveProductOptimizedSceneMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "931ab8926c7b1f26c0e310e1bea1d17e",
    "id": null,
    "metadata": {},
    "name": "useSaveProductOptimizedSceneMutation",
    "operationKind": "mutation",
    "text": "mutation useSaveProductOptimizedSceneMutation(\n  $input: SceneInput!\n) {\n  updateScene(input: $input) {\n    scene {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "914e2253d48b2832d19a4b02b2c90693";

export default node;
